import { render, staticRenderFns } from "./student.vue?vue&type=template&id=1c55ff48&scoped=true"
import script from "./student.vue?vue&type=script&lang=js"
export * from "./student.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c55ff48",
  null
  
)

export default component.exports